import React from 'react';
import PropTypes from 'prop-types';
import './Landingpage.css';
import { withStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
const styles = theme => ({});
class Landingpage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { className, onSidebarOpen, ...rest } = this.props;

    return (
      <Grid container xs={12}>
        <Grid
          container
          xs={12}
          style={{
            justifyContent: 'center',
            paddingBottom: '20px',
            borderBottom: '1px solid grey'
          }}>
          <Grid container lg={8} xs={9}>
            <Grid item xs={12} align="center">
              <Typography className="header">Menu</Typography>
            </Grid>
            <Grid
              container
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0'
              }}>
              <Grid item lg={3} xs={12} align="center">
                <img
                  style={{ maxWidth: '300px' }}
                  width="85%"
                  src="https://img.pngio.com/cartoon-hamburger-images-stock-photos-vectors-shutterstock-cartoon-hamburger-330_280.jpg"
                />
              </Grid>
              <Grid item lg={6} xs={12} align="left">
                <Typography className="itemHeader">
                  Chicken Sandwhich
                </Typography>
                <Typography className="itemContent">
                  Crispy chicken sandwhich served on a bun with pickles
                </Typography>
              </Grid>
              <Grid item lg={3} xs={12} align="center">
                <button className="btnSelect">Select</button>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0'
              }}>
              <Grid item lg={3} xs={12} align="center">
                <img
                  style={{ maxWidth: '300px' }}
                  width="85%"
                  src="https://img.pngio.com/cartoon-hamburger-images-stock-photos-vectors-shutterstock-cartoon-hamburger-330_280.jpg"
                />
              </Grid>
              <Grid item lg={6} xs={12} align="left">
                <Typography className="itemHeader">Cheeseburger</Typography>
                <Typography className="itemContent">
                  100% fresh ground beef served with cheddar cheese
                </Typography>
              </Grid>
              <Grid item lg={3} xs={12} align="center">
                <button className="btnSelect">Select</button>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0'
              }}>
              <Grid item lg={3} xs={12} align="center">
                <img
                  style={{ maxWidth: '300px' }}
                  width="85%"
                  src="https://img.pngio.com/cartoon-hamburger-images-stock-photos-vectors-shutterstock-cartoon-hamburger-330_280.jpg"
                />
              </Grid>
              <Grid item lg={6} xs={12} align="left">
                <Typography className="itemHeader">Veggie Burger</Typography>
                <Typography className="itemContent">
                  Veggie burger made from black beans, brown rice and sunflower
                  seeds served on a bun
                </Typography>
              </Grid>
              <Grid item lg={3} xs={12} align="center">
                <button className="btnSelect">Select</button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          xs={12}
          style={{
            justifyContent: 'center',
            paddingBottom: '20px'
          }}>
          <Grid container lg={6} xs={10}>
            <Grid item xs={12} align="center">
              <Typography className="subHeader">Select Toppings</Typography>
            </Grid>
            <Grid
              container
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0'
              }}>
              <Grid item lg={5} xs={12} align="center">
                <img
                  style={{ maxWidth: '150px' }}
                  width="85%"
                  src="https://img.pngio.com/cartoon-hamburger-images-stock-photos-vectors-shutterstock-cartoon-hamburger-330_280.jpg"
                />
              </Grid>
              <Grid
                container
                lg={7}
                xs={12}
                align="center"
                style={{ justifyContent: 'center' }}>
                <Grid item xs={12}>
                  <Typography className="itemHeader">Lettuce</Typography>
                </Grid>
                <Grid
                  container
                  xs={8}
                  align="center"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '15px'
                  }}>
                  <div className="minusBtn">-</div>
                  <Typography className="option">Yes</Typography>
                  <div className="addBtn">+</div>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0'
              }}>
              <Grid item lg={5} xs={12} align="center">
                <img
                  style={{ maxWidth: '150px' }}
                  width="85%"
                  src="https://img.pngio.com/cartoon-hamburger-images-stock-photos-vectors-shutterstock-cartoon-hamburger-330_280.jpg"
                />
              </Grid>
              <Grid
                container
                lg={7}
                xs={12}
                align="center"
                style={{ justifyContent: 'center' }}>
                <Grid item xs={12}>
                  <Typography className="itemHeader">Tomato</Typography>
                </Grid>
                <Grid
                  container
                  xs={8}
                  align="center"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '15px'
                  }}>
                  <div className="minusBtn">-</div>
                  <Typography className="option">Yes</Typography>
                  <div className="addBtn">+</div>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0'
              }}>
              <Grid item lg={5} xs={12} align="center">
                <img
                  style={{ maxWidth: '150px' }}
                  width="85%"
                  src="https://img.pngio.com/cartoon-hamburger-images-stock-photos-vectors-shutterstock-cartoon-hamburger-330_280.jpg"
                />
              </Grid>
              <Grid
                container
                lg={7}
                xs={12}
                align="center"
                style={{ justifyContent: 'center' }}>
                <Grid item xs={12}>
                  <Typography className="itemHeader">Ketchup</Typography>
                </Grid>
                <Grid
                  container
                  xs={8}
                  align="center"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '15px'
                  }}>
                  <div className="minusBtn">-</div>
                  <Typography className="option">Yes</Typography>
                  <div className="addBtn">+</div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} align="center">
            <button className="orderBtn">Place Order</button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
Landingpage.propTypes = {
  className: PropTypes.string
};

export default withStyles(styles)(Landingpage);
